(function () {
    'use strict';

    angular
        .module('ib-basket-section')
        .controller('ibBasketSectionController', ibBasketSectionController);

    ibBasketSectionController.$inject = ['$rootScope', 'localStorageService', 'DatalayerUtilsService', 'DatalayerMenusService','$timeout','NewMainHeaderFacade','CommonsSessionStorageService'];

    function ibBasketSectionController ($rootScope, localStorageService, DatalayerUtilsService, DatalayerMenusService,$timeout,NewMainHeaderFacade,CommonsSessionStorageService) {
        const vm = this;
        vm.deleteAncillarie = deleteAncillarie;

        function deleteAncillarie (deleteInfo) {
            DatalayerMenusService.deleteAncillaries(vm.model.info.category);
            if (CommonsSessionStorageService.get('actualStepFlow') !== 'availability' && CommonsSessionStorageService.get('actualStepFlow') !== 'ibairp') {
                vm.basketFunctions.isLoading();
                vm.basketFunctions.deleteAncillariesService.deleteAncillarie(deleteInfo).then(() => {
                    vm.model.info = null;
                    vm.model.hasFlexibilization = false;
                    if (localStorageService.get('selectedFlex')) {
                        $timeout(() => {
                            mnttLog2GTM && mnttLog2GTM('ATQ-7625: Adelantar compra de flexibilidad a la dispo','Elimina flex del carrito');
                        });
                    }
                    localStorageService.remove('selectedFlex');
                    $rootScope.$broadcast('basketUpdateCommonHeader');
                    $rootScope.$broadcast('cleanFlexibilization');
                    vm.basketFunctions.calculateAllBasket('/' + localStorageService.get('actualStepFlow'));
                    vm.basketFunctions.saveHeaderModel();
                    vm.basketFunctions.isNotLoading();
                    DatalayerUtilsService.setAncillariesDatalayer();
                }, (error) => {
                    vm.basketFunctions.isNotLoading();
                    vm.basketFunctions.modalService.showGenericError(error).result.then(angular.noop, angular.noop);
                    vm.basketFunctions.collapseHeader.closeCollapse();
                });
            }else {
                vm.basketFunctions.isLoading();
                $timeout(() => {
                    NewMainHeaderFacade.updateBasketFlexibilization('');
                    localStorageService.remove('selectedFlex');
                    $rootScope.$broadcast('emptyFlex');
                    $rootScope.$broadcast('updatePrice', localStorageService.get('headerModel').headerModel.shoppingBasket.total.formatted);
                    vm.ancOffersTotal = localStorageService.get('availabilityRelatedContent')[0].value;
                    $rootScope.$broadcast('changeOffersTotal', vm.ancOffersTotal);
                    vm.basketFunctions.isNotLoading();
                    mnttLog2GTM && mnttLog2GTM('ATQ-7625: Adelantar compra de flexibilidad a la dispo','Elimina flex del carrito');
                    if (CommonsSessionStorageService.get('actualStepFlow') === 'availability') {
                        angular.element('.ib-radio-boxed--simple input').trigger('click');
                    }
                },1500);
            }

        }
    }
})();